// removed by extract-text-webpack-plugin
module.exports = {"change-pass-form":"change-pass-form"};


//////////////////
// WEBPACK FOOTER
// ./components/users/sub-view/change-password-form/_ChangePasswordForm.scss
// module id = ./components/users/sub-view/change-password-form/_ChangePasswordForm.scss
// module chunks = 0